import Swiper from 'swiper/bundle'

export default class SliderActus {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.swiper')
    if (!swiperEl) return

    this.swiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: true,
      navigation: {
        nextEl: this.el.querySelector('.slider-actus--nav-next'),
        prevEl: this.el.querySelector('.slider-actus--nav-prev'),
      },
      breakpoints: {
        992: {
          centeredSlides: false,
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    })
  }
}
